<template>
        <div
         
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
          "
        >


          <div style="display: flex; border-top: 1px solid #d1d1d1; width: 100%; flex-grow: 1; height: 100%">
            <div
              v-for="day in days_number"
              :key="day"
              :ref=" getDay_FF(day) == ttoday() ? 'today' : ''"

              style="
                display: inline-block;
                border-left: 1px solid #eeeeee;
                box-sizing: border-box;
                font-size:8px;
              "
              :style="{
                width: options.day_width + 'px',
                left: day * options.day_width,
                'background-color': getBackgroundColor(options.from_start.add(day, 'days').format('YYYY-MM-DD')) || (options.gray_days.includes(options.from_start.add(day, 'days').day()) ? 'rgb(245 245 245)' : 'transparent'),
              }"  
            >
              {{ getBackgroundTitle(options.from_start.add(day, 'days').format('YYYY-MM-DD')) }}
          </div>
          </div>

        </div>

</template>


<script>
import dayjs from "dayjs";
import "dayjs/locale/it";
export default {
  name: "gant-board",
  props: ["months","days_number","options", "background_colors","segment","match_exact_color"],
  watch: {
    'options': function(){

    }
  },
    methods: {
          HexToRgb(val) {
      if (val.length != 6) {
        throw "Only six-digit hex colors are allowed.";
      }

      var aRgbHex = val.match(/.{1,2}/g);
      var aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16),
      ];
      return aRgb;
  },
  rgb2hsl(rgbArr) {
      var r1 = rgbArr[0] / 255;
      var g1 = rgbArr[1] / 255;
      var b1 = rgbArr[2] / 255;

      var maxColor = Math.max(r1, g1, b1);
      var minColor = Math.min(r1, g1, b1);
      //Calculate L:
      var L = (maxColor + minColor) / 2;
      var S = 0;
      var H = 0;
      if (maxColor != minColor) {
        //Calculate S:
        if (L < 0.5) {
          S = (maxColor - minColor) / (maxColor + minColor);
        } else {
          S = (maxColor - minColor) / (2.0 - maxColor - minColor);
        }
        //Calculate H:
        if (r1 == maxColor) {
          H = (g1 - b1) / (maxColor - minColor);
        } else if (g1 == maxColor) {
          H = 2.0 + (b1 - r1) / (maxColor - minColor);
        } else {
          H = 4.0 + (r1 - g1) / (maxColor - minColor);
        }
      }

      L = L * 100;
      S = S * 100;
      H = H * 60;
      if (H < 0) {
        H += 360;
      }
      var result = [H, S, L];
      return result;
  },
  LightenDarkenColor(col) {
      
      if (col[0] == "#") {
        col = col.slice(1);
      }
      var hsl = this.rgb2hsl(this.HexToRgb(col));
      hsl[2] = 80;
      //return '#aaaaaa30';
      return `hsl(${hsl[0]} ${hsl[1]}% ${hsl[2]}% / 30%)`;
  },
    getDay(index) {
      return this.options.from_start.add(index, "days");
    },
    getDay_FF(index) {
      return this.options.from_start.add(index, "days").format("YYYY-MM-DD");
    },
    ttoday(){
      return dayjs().format("YYYY-MM-DD");
    },
    scrollToDay(container){
      container.scrollTo(this.$refs.today[0].getBoundingClientRect().left - 600,0);
    },
    getBackgroundColor(dateStr) {

      if (!this.background_colors) return null;


      if (this.match_exact_color){
          for (const bg of this.background_colors.filter(x => x.name == this.segment.key.name)) {
            if (dateStr >= bg.start && dateStr <= bg.end) {
              return bg.color;
            }
          }
          return null;
      }

      for (const bg of this.background_colors) {
        if (dateStr >= bg.start && dateStr <= bg.end) {
          return bg.color;
        }
      }
      return null;
    },
    getBackgroundTitle(dateStr) {

      if (!this.background_colors) return null;

      if (this.match_exact_color){
          for (const bg of this.background_colors.filter(x => x.name == this.segment.key.name)) {
            if (dateStr >= bg.start && dateStr <= bg.end) {
              return bg.prop_label;
            }
          }
          return null;
      }

      return null;
    }
  }
};
</script>

<style scoped>
.events-container {
  background: #f7f7f7;
  height: 200px;
  height: 100%;
  position: relative;
}

.event {
  z-index: 1;
  display: inline-block;
  background-color: #673ab7;
  color: #fff;
  position: absolute;
  border-radius: 3px;
  padding: 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

.event .event_drag {
  min-width: 10px;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
}

.hide {
  right: -320px !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>